import React, { useState, Fragment, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import Articolo from './Articolo';
import ArticoloBase from './ArticoloBase';
import SezioneBoxed from './SezioneBoxed'; // Assicurati che questo componente sia disponibile o rimuovilo se non usato
import { Button, Header, Icon, Modal, Image, Input } from 'semantic-ui-react';

const ListaArticoli = ({ idNegozio, abbonamentoUtente, articoli, categorieArticoli, componentiArticolo, associazioniComponenteArticolo, ordiniAttivi }) => {
    const { register, handleSubmit, setValue, watch, errors } = useForm();
    const [aperturaModale, setAperturaModale] = useState(false);
    const [aperturaModaleImg, setAperturaModaleImg] = useState(false);
    const [titoloModale, setTitoloModale] = useState('');
    const [messaggioModale, setMessaggioModale] = useState('');
    const [urlImgModale, setUrlImgModale] = useState('');
    const [searchQuery, setSearchQuery] = useState(''); // Nuovo stato per la barra di ricerca

    let history = useHistory();

    // Funzione per avviare il modale di messaggio
    const avviaModale = (titolo, testo) => {
        setAperturaModale(true);
        setTitoloModale(titolo);
        setMessaggioModale(testo);
    };

    // Funzione per avviare il modale dell'immagine
    const avviaModaleImg = (url) => {
        window.history.pushState('backPressed', null, null);
        window.history.pushState('dummy', null, null);
        window.addEventListener('popstate', chiudiModaleImg, { once: true });
        setAperturaModaleImg(true);
        setUrlImgModale("https://www.ordinasicuro.it/670914_920408/lib/img_articoli/img_articoli_compressed/" + url);
    };

    // Funzioni per chiudere i modali
    const chiudiModale = () => setAperturaModale(false);
    const chiudiModaleImg = () => {
        setAperturaModaleImg(false);
        // Rimuovi l'evento popstate quando il modale immagine è chiuso
        window.removeEventListener('popstate', chiudiModaleImg);
    };

    // Gestore per l'invio del form
    const onSubmit = data => {
        let arrayTotale = Object.entries(data);
        arrayTotale = arrayTotale.filter((elemento) => elemento[1] !== '0' && elemento[1] !== '' && elemento[1] !== undefined);

        // Maggiore di 1 perché c'è sempre l'id del negozio
        if (arrayTotale.length > 1) {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: JSON.stringify(arrayTotale)
            };

            fetch('https://ordinasicuro.it/670914_920408/lib/api/crea_ordine', requestOptions)
                .then(response => response.json())
                .then(dati => {
                    if (dati.presenza_errori === false) {
                        if (dati.presenza_composti === true) {
                            history.push("/conferma-composti2/" + dati.id_ordine_creato);
                        } else {
                            history.push("/conferma-ordine/" + dati.id_ordine_creato);
                        }
                    } else {
                        avviaModale('Attenzione', 'Si è verificato un errore durante l\'invio del tuo ordine. Riprova di nuovo.');
                    }
                })
                .catch(error => {
                    console.error('Errore durante la creazione dell\'ordine:', error);
                    avviaModale('Errore di Rete', 'Impossibile connettersi al server. Controlla la tua connessione.');
                });
        } else {
            avviaModale('Attenzione', 'Per proseguire devi ordinare almeno un prodotto');
        }
    };

    // Funzione per gestire il cambiamento nella barra di ricerca
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Filtra gli articoli in base alla query di ricerca
    const filteredArticoli = articoli.filter(articolo => {
        if (searchQuery.trim() === '') {
            return true; // Se la query è vuota, mostra tutti gli articoli
        }
        const lowerCaseQuery = searchQuery.toLowerCase();
        return (
            articolo.nome.toLowerCase().includes(lowerCaseQuery) ||
            (articolo.descrizione && articolo.descrizione.toLowerCase().includes(lowerCaseQuery))
        );
    });

    // Mappa le categorie e filtra gli articoli per categoria
    const stampaArticoliPerCategoria = categorieArticoli
        .map(categoriaArticolo => {
            // Filtra gli articoli che appartengono a questa categoria E corrispondono alla ricerca
            const articoliInQuestaCategoria = filteredArticoli.filter(
                articolo => articolo.id_categoria_articolo === categoriaArticolo.id
            );

            // Mostra la categoria solo se contiene articoli filtrati
            if (articoliInQuestaCategoria.length === 0) {
                return null; // Non renderizzare la categoria se non ci sono articoli corrispondenti
            }

            return (
                <div className="w-100 mv4 ph3" key={categoriaArticolo.id}>
                    <h1
                        style={{
                            position: "sticky",
                            top: "105px",
                            marginBottom: "10px",
                            background: "#fff",
                            zIndex: 1,
                            padding: "0.5rem 10px",
                            borderBottom: "1px solid #eee",
                        }}
                    >
                        {categoriaArticolo.nome}
                    </h1>
                    <a id={"categoria-" + categoriaArticolo.nome} style={{ "position": "relative", "top": "-160px" }}></a>
                    {articoliInQuestaCategoria.map(articoloFiltrato => {
                        if (articoloFiltrato.visibilita === '1') {
                            if (abbonamentoUtente !== '2' && abbonamentoUtente !== '0' && ordiniAttivi === 1) {
                                return (
                                    <Articolo
                                        key={articoloFiltrato.id}
                                        register={register}
                                        setValue={setValue}
                                        avviaModaleImg={avviaModaleImg}
                                        id={articoloFiltrato.id}
                                        visibilita={articoloFiltrato.visibilita}
                                        nome={articoloFiltrato.nome}
                                        tipologia={articoloFiltrato.tipologia}
                                        id_categoria_articolo={articoloFiltrato.id_categoria_articolo}
                                        descrizione={articoloFiltrato.descrizione}
                                        unita_misura={articoloFiltrato.unita_misura}
                                        allergeni={articoloFiltrato.allergeni}
                                        prezzo={articoloFiltrato.prezzo}
                                        url_immagine={articoloFiltrato.url_immagine}
                                        componentiArticolo={componentiArticolo}
                                        associazioniComponenteArticolo={associazioniComponenteArticolo}
                                    />
                                );
                            } else {
                                return (
                                    <ArticoloBase
                                        key={articoloFiltrato.id}
                                        register={register}
                                        setValue={setValue}
                                        avviaModaleImg={avviaModaleImg}
                                        id={articoloFiltrato.id}
                                        visibilita={articoloFiltrato.visibilita}
                                        nome={articoloFiltrato.nome}
                                        tipologia={articoloFiltrato.tipologia}
                                        id_categoria_articolo={articoloFiltrato.id_categoria_articolo}
                                        descrizione={articoloFiltrato.descrizione}
                                        unita_misura={articoloFiltrato.unita_misura}
                                        allergeni={articoloFiltrato.allergeni}
                                        prezzo={articoloFiltrato.prezzo}
                                        url_immagine={articoloFiltrato.url_immagine}
                                        componentiArticolo={componentiArticolo}
                                        associazioniComponenteArticolo={associazioniComponenteArticolo}
                                    />
                                );
                            }
                        }
                        return null; // Non renderizzare articoli con visibilità diversa da '1'
                    })}
                </div>
            );
        });

    return (
        <Fragment>

            {/* Barra di ricerca */}
            <div
                className="mt4 ph3 pv2" 
                style={{
                    position: "sticky",
                    top: "57px",
                    zIndex: 1,
                    background: "#fff",
                    width: "100%",
                }}
            >   
                <Input icon='search' placeholder='Cerca un prodotto...' value={searchQuery}
                onChange={handleSearchChange} style={{ width: "100%" }} />
            </div>
            
            <form onSubmit={handleSubmit(onSubmit)} name="form-articoli" id="form-articoli">
                <input ref={register} type="hidden" id="idNegozio" name="idNegozio" value={idNegozio} />

                {stampaArticoliPerCategoria}
            </form>

            {/* Modale di messaggio */}
            <Modal open={aperturaModale} onClose={chiudiModale} basic size='small' closeIcon>
                <Header icon='hand spock' content={titoloModale} />
                <Modal.Content>
                    <p>
                        {messaggioModale}
                    </p>
                </Modal.Content>
                <Modal.Actions>
                    <Button color='green' onClick={chiudiModale} inverted>
                        <Icon name='checkmark' /> Ok
                    </Button>
                </Modal.Actions>
            </Modal>

            {/* Modale immagine */}
            <Modal open={aperturaModaleImg} onClose={chiudiModaleImg} basic closeIcon>
                <Modal.Content image>
                    <Image wrapped size='medium' src={urlImgModale} centered />
                </Modal.Content>
            </Modal>
        </Fragment>
    );
};

export default ListaArticoli;
